import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { DateFilter } from './DateFilter';

export const DateFields = () => {
  const isDesktop = useIsDesktop();

  const dictionary = useDictionary(Dictionary, DICTIONARY.MedicalReferrals)
    .search.advancedSearch;

  return (
    <Stack
      direction='column'
      gap={isDesktop ? '16px' : '24px'}
      margin={isDesktop ? '0 0 48px 0' : '0 0 56px 0'}
      role='group'
      aria-label={dictionary.ariaLabelOpenRequestDate}
    >
      <Typography variant={'body1'}>{dictionary.openRequestDate}</Typography>
      <DateFilter />
    </Stack>
  );
};
